<template>
    <PopupRouterViewDetail label="Batch Close Work Order" :isShowCopyData="false" :isBusy="isBusy">

        <b-card header="Work Order Process" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="12">
                    <app-input-textbox id="input-work-order-process-ids" label-cols-lg="12" label="WOPD ID (Separate by ',')" size="sm" :model.sync="ids" />
                    <app-input-textbox id="input-work-order-process-remarks" label-cols-lg="12" label="Remarks" size="sm" :model.sync="remarks" />
                </b-col>
            </b-row>
        </b-card>

        <template #modal-left-button>
            <b-button :disabled="isBusy" size="sm" variant="outline-danger" @click="forceClose">Batch Close</b-button>
        </template>

    </PopupRouterViewDetail>
</template>
<script>
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppInputTextbox from '@/components/AppInputTextbox';

export default {
    components: {
        PopupRouterViewDetail,
        AppInputTextbox,
    },
    data() {
        return {
            ids: '',
            remarks: '',
            isBusy: false,
        }
    },
    methods: {
        async forceClose() {
			try {
				this.isBusy = true;
				const response = await this.$http.post(`workorderprocess/batchcloseworkorder/`, {
                    ids: this.ids,
                    remarks: this.remarks
                }, {
					header: {
						'Content-Type': 'text/plain'
					}
				});
                console.log("response batch", response);
				if(response && response.data) {
					// this.$bvToast.toast("Succeed Closing Work Order", {
					// 		title: 'Work Order Closed',
					// 		variant: 'success',
					// 		solid: true,
					// 		autoHideDelay: 3000 // Optional: Mengatur durasi pesan
					// });

                    let data = response.data;
                    if(Object.keys(data.success).length > 0) {
                        const succeedIds = Object.keys(data.success).join(', ');

                        this.$bvToast.toast(`Succeed Closing Work Order For Id: ${succeedIds}`, {
							title: 'Work Order Closed',
							variant: 'success',
							solid: true,
							autoHideDelay: 10000 // Optional: Mengatur durasi pesan
					    });
                    }

                    if(Object.keys(data.failed).length > 0) {
                        Object.entries(data.failed).forEach(([id, message]) => {
                            this.$bvToast.toast(message, {
                                title: `Failed Closing Work Order with id: ${id}`,
                                variant: 'danger',
                                solid: true,
                                autoHideDelay: 9999999 // Optional: Mengatur durasi pesan
                            });
                        })
                    }

                    this.ids = '';
                    this.remarks = '';
                    this.isBusy = false;	
				}
			} catch(error) {
                this.ids = '';
                this.remarks = '';
                this.isBusy = false;
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			}
		},
    }
}
</script>